import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CmpsFocusItemModule } from '@cmps/ng-kit';
import {
    CmpsAccordionModule,
    CmpsButtonModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsMenuModule,
    CmpsScrollbarModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { ChatService } from '../../../coaching-base/chat.service';
import { CmpsCoachingTagsModule } from '../../../coaching-tags/coaching-tags.module';
import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';
import { epicObs } from '../../../store';

import { TeamschatSummaryComponent } from './teamschat-summary.component';
import { teamschatSummaryEpics } from './teamschat-summary.epic';
import { TranslationIdMap } from './teamschat-summary.i18n';

@NgModule({
    declarations: [TeamschatSummaryComponent],
    exports: [TeamschatSummaryComponent],
    imports: [
        CmpsAccordionModule,
        CmpsButtonModule,
        CmpsCoachingTagsModule,
        CmpsCommonModule,
        CmpsFilterModule,
        CmpsFocusItemModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMenuModule,
        CmpsScrollbarModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [ChatService],
})
export class CmpsTeamscallTeamschatSummaryModule {
    constructor() {
        teamschatSummaryEpics.forEach((e) => epicObs.next(e));
    }
}
